import type { PropsWithChildren, JSX } from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '../../../../theme';

export type ButtonBarProps = {
  spacing: number;
  align?: 'flex-start' | 'center' | 'flex-end';
  className?: string;
};

export const ButtonBar = ({
  children,
  spacing,
  className,
  align = 'center',
}: PropsWithChildren<ButtonBarProps>): JSX.Element => {
  const theme = useTheme();
  return (
    <Box
      className={className}
      data-testid='buttonbar'
      sx={{
        display: 'flex',
        columnGap: theme.spacing(spacing),
        flexDirection: 'row',
        justifyContent: align,
        alignItems: 'center',
      }}
    >
      {children}
    </Box>
  );
};
